//import { StrictMode } from 'react';
//import { createRoot } from 'react-dom/client';
//import App from './App.tsx';
//import './index.css';

//createRoot(document.getElementById('root')!).render(
//<StrictMode>
    //<App />
  //</StrictMode>
//);
// src/main.tsx
import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Service Worker Registration
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator && typeof window !== 'undefined') {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered successfully:', registration);
      
      // Handle service worker updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New service worker installed, reload to activate');
            }
          });
        }
      });
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
};

// Initialize app
const initializeApp = () => {
  registerServiceWorker();
};

// App wrapper with initialization
const AppWrapper = () => {
  useEffect(() => {
    initializeApp();
  }, []);

  return <App />;
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWrapper />
  </StrictMode>,
)